import { Navigate, useLocation, useParams } from 'react-router-dom';

const RedirectLegacyInvestorOperationsRoute = () => {
  const { investorId } = useParams<{ investorId: string }>();
  const location = useLocation();
  const pathname = investorId ? `/home/clients/${encodeURIComponent(investorId)}` : '/home/clients';

  return (
    <Navigate
      to={{
        pathname,
        search: location.search,
      }}
      replace
      state={location.state ?? null}
    />
  );
};

export default RedirectLegacyInvestorOperationsRoute;
